import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconWishlistPath = 'M22,3.99999996 L7.99999996,3.99999996 C6.34314572,3.99999996 4.99999996,5.34314571 4.99999996,6.99999996 L4.99999996,27.0031556 L14.567,23.7 L15.432,23.7 L25,27.0031556 L25,6.99999996 C25,5.34314571 23.6568543,3.99999996 22,3.99999996 Z M22,5.99999997 L22.1166212,6.0067277 C22.6139598,6.0644928 23,6.48716413 23,6.99999997 L23,24.196 L15.7677609,21.7 L14.2322391,21.7 L6.99999997,24.196 L6.99999997,6.99999997 C6.99999997,6.44771522 7.44771522,5.99999997 7.99999997,5.99999997 L22,5.99999997 Z M17.518,8.38 L17.3170284,8.38557051 C16.5300794,8.42928834 15.801796,8.72830692 15.2188202,9.21096412 L15.031,9.377 L15.0159217,9.36114447 C14.3610479,8.74673007 13.4902036,8.38 12.547,8.38 C10.522466,8.38 8.89,10.0468471 8.89,12.092 C8.89,13.009983 9.22626901,13.8763452 9.81607129,14.5594975 L10.0138932,14.7621068 L14.3237478,19.0859595 C14.7144034,19.4778837 15.3490819,19.4780325 15.7399211,19.0862915 L20.0914497,14.72529 L20.1477027,14.6660616 C20.8018782,13.9780495 21.175,13.0639011 21.175,12.092 C21.175,10.0468471 19.542534,8.38 17.518,8.38 Z M17.518,10.38 C18.4285271,10.38 19.175,11.1421942 19.175,12.092 L19.1669974,12.2604655 C19.1351451,12.5939251 19.009161,12.9048842 18.8061453,13.1632674 L18.69,13.297 L15.032,16.964 L11.371987,13.2924806 L11.2801068,13.1988932 C11.0474259,12.925287 10.89,12.5196956 10.89,12.092 C10.89,11.1421942 11.6364729,10.38 12.547,10.38 C13.1885216,10.38 13.7617331,10.765458 14.0337096,11.3581018 L14.0910201,11.4984624 C14.3938648,12.3404193 15.5442333,12.3786901 15.9241256,11.6132747 L15.9729799,11.4984624 C16.2143693,10.8273611 16.8268089,10.38 17.518,10.38 Z';
var NavigationIconWishlistActivePath = 'M19.392,14.097 L19.386,14.104 C19.369,14.121 19.351,14.139 19.333,14.156 L15,18.5 L10.688,14.174 C10.658,14.145 10.628,14.116 10.599,14.084 L10.54,14.026 L10.55,14.024 C10.123,13.543 9.857,12.911 9.857,12.212 C9.857,10.714 11.047,9.5 12.514,9.5 C13.659,9.5 14.626,10.243 15,11.28 C15.373,10.243 16.341,9.5 17.486,9.5 C18.953,9.5 20.143,10.714 20.143,12.212 C20.143,12.946 19.854,13.609 19.391,14.097 L19.392,14.097 Z M22,4 L8,4 C6.346,4 5,5.346 5,7 L5,26.965 L14.678,23.67 C14.885,23.601 15.114,23.601 15.322,23.67 L25,26.965 L25,7 C25,5.346 23.654,4 22,4 L22,4 Z';
var NavigationIcon = baseIcon('NavigationIconWishlist', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconWishlistActivePath : NavigationIconWishlistPath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconWishlist = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconWishlist',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconWishlist.displayName = 'NavigationIconWishlist';
export default NavigationIconWishlist;
//# sourceMappingURL=index.js.map